var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "c-table-cell" }, [
    _c("div", { staticClass: "c-table__cell-value" }, [
      _c(
        "a",
        {
          attrs: { href: `javascript:void(0)` },
          on: {
            click: function ($event) {
              return _vm.goToCandidateProfile(_vm.data.candidate.id)
            },
          },
        },
        [_vm._v(" " + _vm._s(_vm.data.value) + " ")]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }